import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import { getAnalytics, logEvent } from 'firebase/analytics';
var analytics = getAnalytics();
export default {
  name: 'Index',
  data: function data() {
    return {
      num: 0
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当钩子执行前，组件实例还没被创建
    console.log('beforeRouteEnter');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    console.log('beforeRouteUpdate');
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log('beforeRouteLeave');
    next();
  },
  methods: {
    loadImage: function loadImage() {
      this.num = $(window).width() - $('.default').width();
    },
    toLogin: function toLogin() {
      this.$router.push({
        path: '/login'
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    window.onload = function () {
      that.$toast('首屏加载时间为' + (new Date().getTime() - performance.timing.navigationStart) + 'ms');
    };
    // eslint-disable-next-line no-undef
    logEvent(this.analytics, 'Average_ClubPageview_Time', {
      ClubPageview_Time: '',
      ClubPageview_Num: '',
      Average_ClubPageview_Time: ''
    });
  } // beforeCreate() {
  //   document.body.classList.add('fullScreen')
  // },
  // beforeDestroy() {
  //   document.body.classList.remove('fullScreen')
  // }
};